define('app/knockoutExtensions/visibleAnimated',['knockout'], function (ko) {
    ko.bindingHandlers.visibleAnimated = {
        init: function (element, valueAccessor) {
            $(element).hide();
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var value = valueAccessor();
            var show = ko.unwrap(value);
            var $element = $(element);

            if (show) {
                $element.slideDown(80);
                $element.closest('.accordion-group').addClass('active');
            } else {
                $element.slideUp(120);
                $element.closest('.accordion-group').removeClass('active');
            }
        }
    };
});
